import { useIsUserModelCreator } from "@/hooks/useFinancialDeckPermissions";
import { Group } from "@mantine/core";
import { MakeACopyButton } from "./MakeACopyButton";
import { SharingButton } from "./SharingButton";

export const Sharing = () => {
  const [isUserModelCreator] = useIsUserModelCreator();

  return (
    <Group>
      {isUserModelCreator && <SharingButton />}
      {!isUserModelCreator && <MakeACopyButton />}
    </Group>
  );
};
